import React from 'react';
import './super_admin_employee_master.css';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api, image_api } from '../../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import { Button,Row,Col } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../../SuperAdmin/Layout';
import Pagination from 'react-js-pagination';


const SuperAdminEmployeeMaster = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [roles, setRole] = useState([]);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);

  const [DeleteId, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    name: "", 
    email: null, 
    password: null,
    mobile: null,
    role_name: "",
    role_id:'',
    profile_image: null,
    shop_name:"",
    shop_address:"",
    shop_image:null,
    shop_mobile:"",
    currency:"",
    country:"",
    is_active: ''
});
const [updateformData, setUpdateFormData] = useState({
  id:null,
  name: "", 
    email: null, 
    password: null,
    mobile: null,
    role_name: "",
    role_id:'',
    profile_image: null,
    shop_name:"",
    shop_address:"",
    shop_image:null,
    shop_mobile:"",
    currency:"",
    country:"",
    is_active: ''
});

    useEffect(() => {
        fetchTables();
        fetchRole();
      }, []);
      const fetchRole = async (id) => {
        const token = localStorage.getItem('SAtoken');
        console.log(id)
        const shopId =localStorage.getItem('SAShopId');
        try {
           const response = await axios.get(`${var_api}admin-role/get`,{
            headers:{
              Authorization:`${token}`
            }
           });
           console.log("response",response)
          const user =response.data;
          setRole(user);
          
        } catch (error) {
          console.log(error);
          setRole([])
        }
      };

      const fetchTables = async (id) => {
        const token = localStorage.getItem('SAtoken');
        setLoading(true);
        console.log(id)
        const shopId =localStorage.getItem('SAShopId');
        try {
           const response = await axios.get(`${var_api}admin-employee/get`,{
            headers:{
              Authorization :`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data || [];
          setTables(user);
          
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      };


//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};

   const [selectedRole, setSelectedRole] = useState({});
   const handleCodeSelectChange = (selectedOption) => {
     setSelectedRole(selectedOption);
   };
   const handleCodeSelectChangeEdit = (selectedOption) => {
    setUpdateFormData((prevState) => ({
      ...prevState,
      role_id: selectedOption.value,
      role_name: selectedOption.label,
    }));
  };
  
   const [profileImage, setProfileImage] = useState(null);
   const [shopImage, setShopImage] = useState(null);
   const handleImageChange = (e) => {
     setProfileImage(e.target.files[0]);
   };
   
   const handleShopImageChange = (e) => {
     setShopImage(e.target.files[0]);
   };
   
      //post the form data
      const Submit = async (e) => {
        e.preventDefault();
      
        try {
          const token = localStorage.getItem('SAtoken'); // Fetch token from localStorage
          const shopId=localStorage.getItem('SAShopId');
          // Create a FormData object
          const formDataToSend = new FormData();
          formDataToSend.append('name', formData.name);
          formDataToSend.append('role_id', selectedRole.value); // Assuming `selectedRole` holds the role details
          formDataToSend.append('role_name', selectedRole.label); // Assuming label contains role name
          formDataToSend.append('email', formData.email);
          formDataToSend.append('password', formData.password);
          formDataToSend.append('mobile', formData.mobile);
          formDataToSend.append('shop_name', formData.shop_name);
          formDataToSend.append('shop_address', formData.shop_address);
          formDataToSend.append('shop_mobile', formData.shop_mobile);
          formDataToSend.append('currency', formData.currency);
          formDataToSend.append('country', formData.country);
          formDataToSend.append('shop_id', shopId); // Assuming `selectedRole` holds the role details

          if (profileImage) formDataToSend.append('profile_image', profileImage); // Assuming `profileImage` holds the selected image file
          if (shopImage) formDataToSend.append('shop_image', shopImage);
          formDataToSend.append('is_active', 1); // Assuming active status is always true
      
      
          // Send POST request
          const response = await axios.post(`${var_api}admin-employee/post`, formDataToSend, {
            headers: {
              Authorization: `${token}`,
              'Content-Type': 'multipart/form-data', // Ensure the correct Content-Type
            },
          });
      
          if (response.status === 201 || response.status === 200) {
            Swal.fire("Success", "Employee created successfully!", "success");
            setCreate(false); // Close the modal
            fetchTables(); // Refresh the employee list
            setFormData({});
          }
        } catch (error) {
          console.error("Error while creating employee:", error);
          Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
        } 
      };

     //delete method for remove UOM
   const handleDeleteEmployeee = (id) => {
    setShow(true);
    setEmployeeD({id:id})
    }


    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('SAtoken');
      axios.delete(`${var_api}admin-employee/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchTables(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "Employee removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Employee not found");
          }
        })
        .catch((error) => {
          console.error("Error executing the request:", error);
          Swal.fire("Error", `${error.response.data.message}`, "error");
        });
      };

      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage] = useState(10); // Number of items per page
      const [searchTerm, setSearchTerm] = useState('');
      
      // Filtering tables based on search term
      const filteredTables = (tables || []).filter((item) => {
        return (
            item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.mobile?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.role_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.email?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });
    
      // Pagination logic
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = Array.isArray(filteredTables)
    ? filteredTables.slice(indexOfFirstItem, indexOfLastItem)
    : [];
const totalItems = Array.isArray(filteredTables) ? filteredTables.length : 0;


      
      const handleSearchInput = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to the first page when search changes
      };
      
      const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
      };
    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
          id:data.id,
          name: data.name, 
          email: data.email, 
          password: data.password,
          mobile: data.mobile,
          role_name: data.role_name,
          role_id:data.role_id,
          profile_image: data.profile_image,
          is_active: data.is_active,
          shop_id:data.shop_id,
          shop_name:data.shop_name,
          shop_address:data.shop_address,
          shop_mobile:data.shop_mobile,
          shop_image:data.shop_image,
          currency:data.currency,
          country:data.country
      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
      setFormData({});
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};


//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile_image: file });
};

const handleShopUpdateChange = (e) => {
    const file = e.target.files[0];
    console.log("file",file)
    setUpdateFormData({ ...updateformData, shop_image: file });
  };
  


//update method for employee
//post method for updating the food
const handleUpdateSubmit = async (e) => {
  e.preventDefault();  
  console.log("updateformData",updateformData);
 
  

  const formDataToSend = new FormData();
  formDataToSend.append('name', updateformData.name);
  formDataToSend.append('email', updateformData.email);
  formDataToSend.append('password', updateformData.password);
  formDataToSend.append('mobile', updateformData.mobile);
  formDataToSend.append('role_name', updateformData.role_name);
  formDataToSend.append('profile_image', updateformData.profile_image); 
  formDataToSend.append('role_id', updateformData.role_id);
  formDataToSend.append('is_active', updateformData.is_active);
  formDataToSend.append('shop_id', updateformData.shop_id); 
  formDataToSend.append('shop_name', updateformData.shop_name);
  formDataToSend.append('shop_address', updateformData.shop_address);
  formDataToSend.append('shop_image', updateformData.shop_image);
  formDataToSend.append('shop_mobile', updateformData.shop_mobile);
  formDataToSend.append('currency', updateformData.currency);
  formDataToSend.append('country', updateformData.country);
  

   try {
    const token=localStorage.getItem('SAtoken');
    const response = await fetch(`${var_api}admin-employee/put/${updateformData.id}`, {
      method: 'PUT',
    body: formDataToSend,
    headers:{
      Authorization:`${token}`
    }
  }
);
    if(response.status == 200){
      fetchTables();
      setIsEdit(false);
      Swal.fire({
        title: 'Success',
        text: 'Employee Updated Successfully.',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
      
      const data = await response.json();
      console.log('Registration successful!',data);
   
    }else {
      console.error('Failed to Update Food:', response.statusText);
      // Handle error, e.g., show an error message to the user
      Swal.fire({
        title: 'error',
        text: 'Failed to Update Food...Please Try Again!',
        icon: 'error',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    }
    
    // Handle success scenario as needed
  } catch (error) {
      console.error('Error:', error);
      // Handle error scenario as needed
    }
  };
  const handleToggle1 = (isChecked, item) => {
    const formData = new FormData();
    formData.append("shop_id", item.shop_id);
    formData.append("name", item.name);
    formData.append("email", item.email);
    formData.append("mobile", item.mobile);
    formData.append("password", item.password);
    formData.append("profile_image", item.profile_image); // Assuming `profile_image` is a file or URL
    formData.append("role_id", item.role_id);
    formData.append("role_name", item.role_name);
    formData.append("shop_name", item.shop_name);
    formData.append("shop_address", item.shop_address); // Assuming `profile_image` is a file or URL
    formData.append("shop_image", item.shop_image);
    formData.append("shop_mobile", item.shop_mobile);
    formData.append("currency", item.currency);
    formData.append("country", item.country);
    formData.append("is_active", isChecked ? 1 : 0); // Convert boolean to 1 or 0
  
    const token = localStorage.getItem("SAtoken");
  
    axios
      .put(`${var_api}admin-employee/put/${item.id}`, formData, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          Swal.fire("Success", "Status updated successfully!", "success");
          fetchTables();
        } else {
          Swal.fire("Error", "Failed to update status!", "error");
        }
      })
      .catch((error) => {
        console.error("Error updating status:", error);
        Swal.fire("Error", `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
      });
  };
  



    return(
      <>         
      <Layout>
        <Col lg="12">
      
          
      <div style={{border:"none",padding:"20px",width:"98%",height:"auto",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
      <div className='d-flex justify-content-between'> 
      <h4 className='ushesaem'>EMPLOYEE MASTER</h4>

      <h5 style={{fontFamily:"serif",fontWeight:"bolder"}}>Total Employees: <span style={{color:"green"}}>{tables.length}</span></h5> 
      <Row>
            {/* <Button  onClick={handleShow} class="btn btn-info">CREATE </Button> */}
            <Col>
            <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/></Col>
              <Col>
                      <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px"}}>Create Employee</Button>
                      </Col> </Row>
</div>  <div>
     
      
    <br/>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Profile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Password</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Role</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Email</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Shop Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Shop Address</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Shop Mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Shop Image</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Currency</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Country</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody class="body-half-screen">
   {currentItems && currentItems.length > 0 ? (
   currentItems && currentItems.map((data,index) =>(

    <tr style={{padding:"7px"}}>
      <th scope="row">{index+1}</th>
      <td style={{textTransform:"capitalize",textAlign:"left"}}><img src={`${image_api}/${data.profile_image}`}  alt='profile' width="65px" height="60px" /></td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.name}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.password}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.role_name}</td>
      <td style={{textAlign:"left"}}>{data.email}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.mobile}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.shop_name}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.shop_address}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.shop_mobile}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}><img src={`${image_api}/${data.shop_image}`}  alt='profile' width="65px" height="60px" /></td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.currency}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.country}</td>
      <td style={{alignContent:"left"}}> <div className="form-check form-switch" >
      <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={data.is_active === 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleToggle1(e.target.checked, data)}
            />
</div></td>
      <td> 
      <i class="bi bi-pencil-square" onClick={()=>handleUpdateEmployee(data)}   style={{fontSize:"20px",color:"rgb(9, 97, 9)"}}></i>{' '}
      <i class="bi bi-trash" onClick={()=>handleDeleteEmployeee(data.id)}   style={{fontSize:"21px",color:"rgb(175, 2, 2)"}}></i>
      </td>
     
    </tr>
   ))
   ) : (
    <tr>
      <td colSpan="9" style={{ textAlign: "center", color:"grey", borderColor:"black" }}>
        No Data Available
      </td>
    </tr>
   )}
 

   </tbody>
}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
 
      </Col>
  
      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Employee </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleUpdateSubmit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Employee Name</label>
              <input type="text" class="form-control" placeholder="enter employee name" id="input1" value={updateformData.name}  name="name"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
              <label for="input2" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Employee Email</label>
              <input type="email" class="form-control" placeholder="enter employee email" id="input2" name="email" value={updateformData.email} onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
               <label for="input3" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Password</label>
              <input type="text" class="form-control" placeholder="enter password" id="input3"  name="password" value={updateformData.password} onChange={handleInputUpdateChange} style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Phone No</label>
              <input type="number" class="form-control" placeholder="enter phone no" id="input4" name="mobile" value={updateformData.mobile} onChange={handleInputUpdateChange} style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col" style={{zIndex:"2"}}>
               <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Role</label>
               {/* <Select
                        options={roles}
                        placeholder="Select Role"
                        isSearchable={true}
                        className="customSelect mb-3"
                        Value={{ value: updateformData.role_name, label: updateformData.role_id }}
                        onChange={handleRoleUpdateChange}
                        styles={{
                          // Styles for increasing width and height
                          control: (provided, state) => ({
                            ...provided,
                            width: '370px', // Adjust height as needed
                            borderRadius: '12px'
                          }),
                        }}
                         /> */}
                                                  <Select
  options={roles.map((role) => ({
    label: role.role_name,
    value: role.id,
  }))}
  placeholder="Select Category"
  onChange={handleCodeSelectChangeEdit}
  isSearchable={true}
  value={{ value: updateformData.role_id, label: updateformData.role_name }}

  className="customSelect mb-3"
  styles={{
    control: (provided) => ({
      ...provided,
      minWidth: "350px",
      minHeight: "50px",
      borderRadius: "10px",
    }),
  }}
/>
            </div>
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Employee Image{" "}</label>
              <input type="file" class="form-control" id="formFile"  name='profile'  style={{borderRadius:"12px"}} onChange={handleImageUpdateChange} />
            </div>
          </div>
         <br/>
         <div class="row">
            <div class="col">
               <label for="input3" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Shop Name</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Shop Name" name='shop_name' value={updateformData.shop_name} onChange={handleInputUpdateChange} style={{borderRadius:"15px",height:"50px"}} required />
               </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Shop Address</label>
              <input type="text" class="form-control" id="floatingInput" placeholder="Shop Address" name='shop_address' value={updateformData.shop_address} onChange={handleInputUpdateChange} style={{borderRadius:"15px",height:"50px"}} required/>
              </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
               <label for="input3" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Shop Mobile</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Shop Mobile" name='shop_mobile' value={updateformData.shop_mobile} onChange={handleInputUpdateChange} style={{borderRadius:"15px",height:"50px"}} required />
               </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Shop Image</label>
              <input type="file" class="form-control" id="formFile" onChange={handleShopUpdateChange} name='shop_image'  style={{borderRadius:"15px",height:"50px"}} />
              </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
               <label for="input3" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Currency</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Currency" name='currency' value={updateformData.currency} onChange={handleInputUpdateChange} style={{borderRadius:"15px",height:"50px"}} required 
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^A-Za-z ]/g, ""); // Allow only letters and spaces
                }}
               />
               </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Country</label>
              <input type="text" class="form-control" id="floatingInput" placeholder="Country" name='country' value={updateformData.country} onChange={handleInputUpdateChange} style={{borderRadius:"15px",height:"50px"}} required/>
              </div>
          </div>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Employee </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Employee Name</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="name" name='name' value={formData.name} onChange={handleInputChange}  style={{borderRadius:"15px",height:"50px"}} required/>
               </div>
            <div class="col">
              <label for="input2" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Employee Email</label>
              <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com" name='email' value={formData.email} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
              </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
               <label for="input3" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Password</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="password" name='password' value={formData.password} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required />
               </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Phone No</label>
              <input type="number" class="form-control" id="floatingInput" placeholder="phone" name='mobile' value={formData.mobile} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
              </div>
          </div>
          <br/>
          <div class="row">
            <div class="col" style={{zIndex:"2"}}>
               <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Role</label>
             
                        
                                  <Select
  options={roles.map((role) => ({
    label: role.role_name,
    value: role.id,
  }))}
  placeholder="Select Category"
  onChange={handleCodeSelectChange}
  isSearchable={true}
  className="customSelect mb-3"
  styles={{
    control: (provided) => ({
      ...provided,
      minWidth: "350px",
      minHeight: "50px",
      borderRadius: "10px",
    }),
  }}
/>
            </div>
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Employee Image{" "}</label>
            <input type="file" class="form-control" id="formFile" onChange={handleImageChange} name='profile'  style={{borderRadius:"15px",height:"50px"}} />
            </div>
          </div>
         <br/>
         <div class="row">
            <div class="col">
               <label for="input3" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Shop Name</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Shop Name" name='shop_name' value={formData.shop_name} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required />
               </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Shop Address</label>
              <input type="text" class="form-control" id="floatingInput" placeholder="Shop Address" name='shop_address' value={formData.shop_address} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
              </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
               <label for="input3" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Shop Mobile</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Shop Mobile" name='shop_mobile' value={formData.shop_mobile} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required />
               </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Shop Image</label>
              <input type="file" class="form-control" id="formFile" onChange={handleShopImageChange} name='shop_image'  style={{borderRadius:"15px",height:"50px"}} />
              </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
               <label for="input3" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Currency</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Currency" name='currency' value={formData.currency} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required 
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^A-Za-z ]/g, ""); // Allow only letters and spaces
                }}
               />
               </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Country</label>
              <input type="text" class="form-control" id="floatingInput" placeholder="Country" name='country' value={formData.country} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
              </div>
          </div>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Create</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setCreate(false)} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 
      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large

        centered
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Employee  
          <span style={{color:"red",textTransform:"uppercase"}}></span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
</Modal>

            {/* </div> */}
       </Layout></>

        
    )
}

export default SuperAdminEmployeeMaster;